import type { JSX } from 'react';
import './brand.css';
import { BRAND_ICON_SIZE } from './Icon';

/**
 * Знак платформы — тот же куб, что и в статическом `netdeck.svg`, но грани
 * слетаются в него и разлетаются обратно.
 *
 * Рисунок и движение взяты из `assets/brand/netdeck-anim.svg` — там исходник,
 * с которым работает художник. Через общий набор глифов он пройти не может
 * и лежит поэтому не в `assets/icons`: сборка набора снимает у фигур классы
 * и склеивает всё в одну строку JSX, а движение здесь держится ровно
 * на классах и на блоке правил. Сборка на нём и падала.
 *
 * Цвет — `currentColor`, как у остальных глифов: знак стоит рядом с подписью
 * «NetDeck» и обязан читаться на обеих темах. Плотность граней задаётся
 * прозрачностью, а не тремя разными цветами, — иначе на светлой теме
 * пришлось бы подбирать вторую тройку.
 *
 * Про §12. Запрет там на анимацию **в рабочих областях** — «ничего плавно
 * выезжать» на карте и видеостене; шапка к ним не относится. Но и
 * «микровзаимодействием» бесконечный цикл назвать нельзя, так что послабление
 * §12 сюда тоже не тянется: это решение заказчика про свой знак, и держится
 * оно на обязательном условии — при `prefers-reduced-motion` движения нет
 * вовсе, знак остаётся собранным (см. `brand.css`).
 */
export function BrandMark({ size = BRAND_ICON_SIZE }: { size?: number }): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 140 140"
      fill="currentColor"
      // Смысл несёт подпись «NetDeck» рядом: знак — опора для глаза.
      aria-hidden="true"
      focusable="false"
      style={{ flex: 'none' }}
    >
      <g className="nd-brand">
        <polygon
          className="nd-brand-top"
          points="65.27,66.21 91.88,20.47 39.38,20.47 13.12,66.21"
        />
        <polygon
          className="nd-brand-bottom"
          points="13.12,73.79 39.32,119.52 91.76,119.52 65.62,73.79"
        />
        <polygon
          className="nd-brand-right"
          points="126.88,70 100.62,24.09 74.32,70 100.62,115.91"
        />
      </g>
    </svg>
  );
}
